import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '@/styles/theme/colors';
import { Button } from '@/components/atoms/Button';

export const ChatContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 65,
  right: 24,
  width: '100%',
  maxWidth: '600px',
  height: 'calc(100vh - 82px)',
  zIndex: 9999,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colors.background,
  borderRadius: theme.spacing(1),
  boxShadow: theme.shadows[4],

  [theme.breakpoints.down('sm')]: {
    bottom: 0,
    right: 0,
    height: '100vh',
    maxWidth: '100%',
    borderRadius: 0,
  },
}));

export const ChatHeader = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(2, 3),
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderTopLeftRadius: theme.spacing(1),
  borderTopRightRadius: theme.spacing(1),

  [theme.breakpoints.down('sm')]: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    position: 'fixed',
    top: 0,
    zIndex: 1,
  },
}));

export const ChatHeaderContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const ChatPaper = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 3, 0),
  overflowY: 'auto',
  overflowX: 'hidden',

  [theme.breakpoints.down('sm')]: {
    height: 'calc(100vh - 180px)', // Header height + SendMessage height
    marginTop: theme.spacing(10),
  },
}));

export const SendMessageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  borderTop: `1px solid ${theme.palette.divider}`,

  [theme.breakpoints.down('sm')]: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: colors.background,
    zIndex: 1,
  },
}));

export const SendMessageContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.common.white,
  width: '100%',
  '& .MuiInputBase-root': {
    height: '124px',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      height: '80px',
    },

    '& textarea': {
      height: '100% !important',
      '&::placeholder': {
        color: theme.palette.text.secondary,
        opacity: 0.7,
      },
    },
  },
  '& .MuiButton-root': {
    position: 'absolute',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    minWidth: 'unset',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.text.primary,
    '&:hover': {
      filter: 'brightness(0.8)',
    },
    '&:disabled': {
      backgroundColor: theme.palette.action.disabledBackground,
      '& svg': {
        color: theme.palette.action.disabled,
      },
    },
    '& svg': {
      fontSize: 18,
      color: theme.palette.common.white,
    },
  },
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  alignSelf: 'flex-start',
}));

export const SuggestionsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2),
  overflowX: 'auto',
  scrollbarWidth: 'thin',
  '-webkit-overflow-scrolling': 'touch', // Para scroll suave no iOS
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const Suggestion = styled(Button)(({ theme }) => ({
  width: 'fit-content',
  flexShrink: 0,
  height: 44,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1, 3),
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));
